export const ADD_DELAYED_ACTION = 'waitrose/timeout-actions/ADD_DELAYED_ACTION';
export const CANCEL_DELAYED_ACTION = 'waitrose/timeout-actions/CANCEL_DELAYED_ACTION';

export interface DelayedActionType {
  type: typeof ADD_DELAYED_ACTION | typeof CANCEL_DELAYED_ACTION;
  payload: {
    timerName: string;
  };
}
